// Local store for the MMH Products module, mirrored into localStorage so
// edits survive a refresh while the completedproject API is being built.
//
// Field names and value formats match the real columns exactly — category is
// a master id, direction is a two-letter code, style and image category are
// the legacy strings — so nothing about the screens changes when USE_MOCK
// goes false.

const STORAGE_KEY = "mmh_products_mock_db_v2";

const placeholderImage = (label, hue) => {
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="640" height="440">
    <defs><linearGradient id="g" x1="0" y1="0" x2="1" y2="1">
      <stop offset="0%" stop-color="hsl(${hue},38%,42%)"/>
      <stop offset="100%" stop-color="hsl(${hue + 24},44%,24%)"/>
    </linearGradient></defs>
    <rect width="640" height="440" fill="url(#g)"/>
    <text x="50%" y="50%" fill="rgba(255,255,255,0.92)" font-family="Segoe UI,Roboto,sans-serif"
          font-size="28" font-weight="600" text-anchor="middle" dominant-baseline="middle">${label}</text>
  </svg>`;
  return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`;
};

let imageSeq = 77000;

const makeImage = (title, category, hue, isDp, extra = {}) => ({
  id: ++imageSeq,
  fileName: `${1723273091 + imageSeq}_${(imageSeq % 900) + 1}.jpg`,
  url: placeholderImage(title, hue),
  title,
  category,
  subCategory: extra.subCategory || "",
  otherCategory: "",
  style: extra.style || "Modern",
  keywords: extra.keywords || [],
  description: extra.description || "",
  isDp: Boolean(isDp),
  position: extra.position ?? 0,
  status: 1,
  altName: "",
});

const SEED_PRODUCTS = [
  {
    id: 15129,
    projectCode: "PRJ202405210032",
    projectName: "28X59 house plan- 1652 sqft Residential Exterior Design At Mau [UP]",
    width: "28", length: "59", floor: "1", plotArea: "1652", buildUpArea: "1652",
    staircaseType: 1, vastuPriority: "10", basement: "", direction: "NN",
    clientLocation: "Mau [UP]", clientName: "Ankita Singh", pincode: "465697",
    category: "1", categoryName: "Residential", categoryType: "house",
    projectType: 1, projectCost: "Moderate", productCode: "MMH2859",
    planType: "Premium", parking: 1, addLink: "",
    description: "",
    bedRoom: 3, livingRoom: 1, drawingRoom: 0, kitchen: 1, diningRoom: 1, bathroom: 2,
    customFields: [
      { name: "Garden", value: "1" }, { name: "Puja", value: "1" },
      { name: "Wash Area", value: "1" }, { name: "Dress", value: "1" },
    ],
    status: 1, insertDate: "2024-08-10", userId: 355,
    images: [
      makeImage("Ground Floor Plan", "Floorplan", 210, false, { position: 0, keywords: ["3d elevation", "floor plan"] }),
      makeImage("3D Elevation", "Exterior Design", 28, true, { position: 1, style: "Contemporary", keywords: ["3d elevation", "front elevation"] }),
      makeImage("Rear Elevation", "Exterior Design", 150, false, { position: 2, style: "Contemporary", keywords: ["rear elevation"] }),
    ],
  },
  {
    id: 15128,
    projectCode: "PRJ202405210031",
    projectName: "50X80 Commercial office building plan- 4000 sqft Commercial Floorplan At Bangalore [KA]",
    width: "50", length: "80", floor: "1", plotArea: "4000", buildUpArea: "4000",
    staircaseType: 2, vastuPriority: "5", basement: "-1", direction: "EE",
    clientLocation: "Bangalore [KA]", clientName: "Nexus Realty", pincode: "560001",
    category: "2", categoryName: "Commercial", categoryType: "Commercial office building",
    projectType: 3, projectCost: "High", productCode: "MMH5080",
    planType: "Elite", parking: 1, addLink: "",
    description: "Ground-plus office block with a single basement level for parking.",
    bedRoom: 0, livingRoom: 0, drawingRoom: 0, kitchen: 0, diningRoom: 0, bathroom: 0,
    customFields: [],
    status: 1, insertDate: "2024-08-10", userId: 355,
    images: [
      makeImage("First Floor Plan", "Floorplan", 200, false, { position: 0, keywords: ["office layout"] }),
      makeImage("Ground Floor Plan", "Floorplan", 190, false, { position: 1, keywords: ["office layout"] }),
      makeImage("3D Elevation", "Exterior Design", 34, true, { position: 2, style: "Industrial", keywords: ["commercial elevation"] }),
    ],
  },
  {
    id: 15127,
    projectCode: "PRJ202405210030",
    projectName: "35X35 Primary school plan- 1225 sqft Institutional Floorplan At Indore [MP]",
    width: "35", length: "35", floor: "2", plotArea: "1225", buildUpArea: "2450",
    staircaseType: 1, vastuPriority: "3", basement: "0", direction: "NN",
    clientLocation: "Indore [MP]", clientName: "Saraswati Trust", pincode: "452001",
    category: "4", categoryName: "Institutional", categoryType: "Primary school",
    projectType: 3, projectCost: "Low", productCode: "MMH3535",
    planType: "Basic", parking: 1, addLink: "",
    description: "Two-storey primary school block with six classrooms and a staff room.",
    bedRoom: 0, livingRoom: 0, drawingRoom: 0, kitchen: 0, diningRoom: 0, bathroom: 0,
    customFields: [{ name: "Classrooms", value: "6" }],
    status: 0, insertDate: "2024-08-09", userId: 355,
    images: [makeImage("Ground Floor Plan", "Floorplan", 175, true, { position: 0, keywords: ["school plan"] })],
  },
  {
    id: 15126,
    projectCode: "PRJ202405210029",
    projectName: "40X50 house plan- 2000 sqft Residential Interior Design At Pune [MH]",
    width: "40", length: "50", floor: "1", plotArea: "2000", buildUpArea: "2000",
    staircaseType: 1, vastuPriority: "10", basement: "0", direction: "SW",
    clientLocation: "Pune [MH]", clientName: "Aditi Kulkarni", pincode: "411001",
    category: "1", categoryName: "Residential", categoryType: "Home",
    projectType: 1, projectCost: "Lavish", productCode: "MMH4050",
    planType: "Interior", parking: 1, addLink: "",
    description: "Four-bedroom villa with a fully detailed interior package.",
    bedRoom: 4, livingRoom: 1, drawingRoom: 1, kitchen: 1, diningRoom: 1, bathroom: 3,
    customFields: [],
    status: 1, insertDate: "2024-08-09", userId: 355,
    images: [
      makeImage("Master Bedroom", "Interior Design", 320, true, { position: 0, subCategory: "Bedroom", style: "Scandinavian", keywords: ["bedroom interior"] }),
      makeImage("Living Room", "Interior Design", 280, false, { position: 1, subCategory: "Living room", style: "Contemporary", keywords: ["living room"] }),
      makeImage("Modular Kitchen", "Interior Design", 100, false, { position: 2, subCategory: "Kitchen", style: "Modern", keywords: ["modular kitchen"] }),
      makeImage("Ground Floor Plan", "Floorplan", 205, false, { position: 3, keywords: ["4 bhk plan"] }),
    ],
  },
  {
    id: 15125,
    projectCode: "PRJ202405210028",
    projectName: "50X57 house plan- 2850 sqft Residential Cum Commercial 3D Floorplan At Jaipur [RJ]",
    width: "50", length: "57", floor: "2", plotArea: "2850", buildUpArea: "5700",
    staircaseType: 2, vastuPriority: "7", basement: "0", direction: "WW",
    clientLocation: "Jaipur [RJ]", clientName: "Vikram Singh", pincode: "302001",
    category: "3", categoryName: "Residential Cum Commercial", categoryType: "House With Shop",
    projectType: 2, projectCost: "High", productCode: "MMH5057",
    planType: "Premium", parking: 1, addLink: "",
    description: "Two-storey rental block over two shops.",
    bedRoom: 2, livingRoom: 2, drawingRoom: 1, kitchen: 0, diningRoom: 0, bathroom: 0,
    customFields: [{ name: "Shops", value: "2" }],
    status: 1, insertDate: "2024-08-09", userId: 355,
    images: [
      makeImage("3D Elevation", "3d-floorplan", 20, true, { position: 0, style: "Traditional", keywords: ["3d elevation", "rental block"] }),
      makeImage("Ground Floor Plan", "Floorplan", 195, false, { position: 1, keywords: ["rental plan"] }),
    ],
  },
];

const SEED_KEYWORDS = [
  "3d elevation", "3d elevation design", "front elevation", "rear elevation",
  "floor plan", "ground floor plan", "first floor plan", "2 bhk", "3 bhk",
  "4 bhk", "4 bhk plan", "modern house", "contemporary house", "duplex",
  "villa", "bungalow", "modular kitchen", "bedroom interior", "living room",
  "false ceiling", "corner plot", "east facing", "north facing",
  "vastu compliant", "commercial elevation", "office layout", "school plan",
  "rental block", "rental plan", "terrace garden", "parking", "swimming pool",
  "landscape",
];

const clone = (v) => JSON.parse(JSON.stringify(v));

const readStore = () => {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (raw) {
      const parsed = JSON.parse(raw);
      if (parsed?.products) return parsed;
    }
  } catch (error) {
    // Corrupt or blocked storage — rebuild from the seed rather than crash.
  }
  return { products: clone(SEED_PRODUCTS), keywords: clone(SEED_KEYWORDS) };
};

let store = readStore();

const persist = () => {
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(store));
  } catch (error) {
    // Quota full or unavailable — the in-memory copy still serves this session.
  }
};

export const mockDb = {
  listProducts: () => clone(store.products),

  getProduct: (id) => clone(store.products.find((p) => String(p.id) === String(id)) || null),

  insertProduct: (product) => {
    const nextId = store.products.reduce((max, p) => Math.max(max, Number(p.id) || 0), 0) + 1;
    const record = {
      ...clone(product),
      id: nextId,
      insertDate: new Date().toISOString().slice(0, 10),
      userId: 355,
    };
    store.products.unshift(record);
    persist();
    return clone(record);
  },

  updateProduct: (id, patch) => {
    const i = store.products.findIndex((p) => String(p.id) === String(id));
    if (i === -1) return null;
    store.products[i] = {
      ...store.products[i],
      ...clone(patch),
      id: store.products[i].id,
      insertDate: store.products[i].insertDate,
    };
    persist();
    return clone(store.products[i]);
  },

  deleteProduct: (id) => {
    const before = store.products.length;
    store.products = store.products.filter((p) => String(p.id) !== String(id));
    persist();
    return store.products.length < before;
  },

  nextImageId: () => ++imageSeq,

  searchKeywords: (query) => {
    const q = String(query || "").trim().toLowerCase();
    if (!q) return [];
    return store.keywords.filter((k) => k.toLowerCase().startsWith(q)).slice(0, 12);
  },

  addKeywords: (keywords = []) => {
    let added = false;
    keywords.forEach((keyword) => {
      const value = String(keyword || "").trim();
      if (value && !store.keywords.some((k) => k.toLowerCase() === value.toLowerCase())) {
        store.keywords.push(value);
        added = true;
      }
    });
    if (added) persist();
  },

  reset: () => {
    store = { products: clone(SEED_PRODUCTS), keywords: clone(SEED_KEYWORDS) };
    persist();
  },
};

export default mockDb;
